import React from 'react';
import { SEGMENTS } from './constants';

export const SegmentTicker = () => {
  const items = [...SEGMENTS, ...SEGMENTS];
  return (
    <div className="relative border-y border-white/10 bg-[var(--br-bg-2)] py-6 overflow-hidden" data-testid="segment-ticker">
      <div className="br-ticker">
        {items.map((s, i) => (
          <span key={i} className="br-serif italic text-2xl sm:text-3xl text-white/80 px-8 flex items-center gap-8 whitespace-nowrap">
            {s}<span className="text-[var(--br-teal)] not-italic text-base">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
